import script from "./LootBoxOpenOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./LootBoxOpenOdd.vue?vue&type=script&setup=true&lang=js"

import "./LootBoxOpenOdd.vue?vue&type=style&index=0&id=16c735a1&lang=scss"

const __exports__ = script;

export default __exports__